const PushNotification = {
  cancelAllLocalNotifications: function () {
    // This function does nothing
  },
};

export default PushNotification;
